"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineComponents = void 0;
const featured_navigation_1 = require("../../js/components/featured-navigation/featured-navigation");
const accordeon_1 = require("../components/accordeon");
const accordeon_2 = require("../components/accordeon/accordeon");
const back_to_top_button_1 = require("../components/back-to-top-button");
const body_element_1 = require("../components/body-element/body-element");
const horizontal_product_card_1 = require("../components/cards/product-card/horizontal-product-card");
const product_card_1 = require("../components/cards/product-card/product-card");
const product_card_color_swatches_1 = require("../components/cards/product-card/product-card-color-swatches");
const product_card_media_tabs_1 = require("../components/cards/product-card/product-card-media-tabs");
const vertical_product_card_1 = require("../components/cards/product-card/vertical-product-card");
const carousel_1 = require("../components/carousel");
const cart_count_1 = require("../components/cart-count");
const cart_notification_1 = require("../components/cart-notification");
const clipboard_button_1 = require("../components/clipboard-button");
const collapsed_tags_1 = require("../components/collapsed-tags");
const article_card_1 = require("../components/cards/article-card");
const countdown_timer_1 = require("../components/countdown-timer");
const deffered_media_1 = require("../components/deffered-media");
const float_element_1 = require("../components/float-element");
const free_shipping_bar_1 = require("../components/free-shipping-bar");
const inputs_1 = require("../components/inputs");
const localization_selector_1 = require("../components/localization-selector");
const max_lines_truncate_1 = require("../components/max-lines-truncate");
const modal_1 = require("../components/modal");
const modal_2 = require("../components/modal/modal");
const notification_1 = require("../components/notification");
const pagination_1 = require("../components/pagination");
const pagination_2 = require("../components/pagination/pagination");
const quantity_input_1 = require("../components/quantity-input");
const quantity_1 = require("../components/quantity-input/quantity");
const shape_swatch_1 = require("../components/shape-swatch");
const share_1 = require("../components/share");
const sidebar_1 = require("../components/sidebar");
const sidebar_2 = require("../components/sidebar/sidebar");
const sticky_cart_button_1 = require("../components/sticky-cart-button");
const tabs_1 = require("../components/tabs");
const tab_1 = require("../components/tabs/tab");
const tabs_2 = require("../components/tabs/tabs");
const before_after_images_1 = require("../sections/before-after-images");
const cart_1 = require("../sections/cart");
const cart_drawer_1 = require("../sections/cart-drawer");
const cart_2 = require("../sections/cart/cart");
const collection_page_1 = require("../sections/collection-page");
const sort_list_1 = require("../sections/collection-page/sort-list");
const customer_1 = require("../sections/customer");
const faq_1 = require("../sections/faq");
const header_1 = require("../sections/header");
const hotspots_1 = require("../sections/hotspots");
const lookbook_1 = require("../sections/lookbook");
const map_1 = require("../sections/map");
const map_component_1 = require("../sections/map/map-component");
const password_page_1 = require("../sections/password-page");
const popups_1 = require("../sections/popups");
const product_1 = require("../sections/product");
const product_recommendations_1 = require("../sections/product-recommendations");
const product_modal_image_wrap_1 = require("../sections/product/product-modal-image-wrap");
const product_model_1 = require("../sections/product/product-model");
const quick_view_1 = require("../sections/product/quick-view");
const recently_viewed_1 = require("../sections/recently-viewed");
const scrolling_text_1 = require("../sections/scrolling-text");
const search_drawer_1 = require("../sections/search-drawer");
const video_banner_1 = require("../sections/video-banner");
const utils_1 = require("./utils");
const image_slider_1 = require("../../js/components/image-slider/image-slider");
const close_cursor_1 = require("../../js/components/close-cursor/close-cursor");
const quote_1 = require("../../js/components/quote/quote");
const testimonials_1 = require("../components/testimonials");
const lazy_video_1 = require("../components/body-element/lazy-video");
const header_float_element_btn_1 = require("../components/float-element/header-float-element-btn");
const header_float_element_1 = require("../components/float-element/header-float-element");
const product_info_1 = require("../sections/product/product-info");
const components = [
    header_float_element_btn_1.HeaderFloatElementBtn,
    header_float_element_1.HeaderFloatElement,
    lazy_video_1.LazyVideo,
    customer_1.LoginComponent,
    customer_1.RegisterComponent,
    back_to_top_button_1.BackToTopButton,
    sticky_cart_button_1.StickyCartButton,
    quantity_1.QuantityComponent,
    quantity_input_1.QuantityBtn,
    localization_selector_1.LocalizationSelector,
    notification_1.NotificationComponent,
    tabs_2.TabsComponent,
    tab_1.TabComponent,
    collection_page_1.ListComponent,
    collection_page_1.ListBtn,
    float_element_1.FloatElement,
    hotspots_1.HotspotsFloatElement,
    float_element_1.FloatElementBtn,
    float_element_1.DropdownOpener,
    float_element_1.TooltipTrigger,
    faq_1.FaqSection,
    accordeon_2.AccordeonComponent,
    accordeon_1.AccordeonButton,
    product_card_media_tabs_1.ProductMediaTabs,
    product_card_color_swatches_1.ColorSwatches,
    modal_2.ModalComponent,
    password_page_1.PasswordModal,
    cart_notification_1.CartNotificationPopup,
    modal_1.ModalButton,
    password_page_1.PasswordModalButton,
    sidebar_1.SidebarButton,
    sidebar_2.SidebarComponent,
    search_drawer_1.SearchSidebar,
    quick_view_1.QuickView,
    carousel_1.CarouselComponent,
    carousel_1.CarouselPlayButton,
    carousel_1.CarouselDots,
    carousel_1.CarouselButton,
    carousel_1.CarouselProgress,
    header_1.HeaderComponent,
    header_1.DrawerMenu,
    header_1.DrawerMenuPage,
    header_1.DrawerMenuPageLink,
    pagination_2.PaginationComponent,
    pagination_1.PaginationLoadButton,
    pagination_1.PaginationLink,
    pagination_1.PaginationInfiniteScroll,
    deffered_media_1.DeferredMedia,
    product_1.PickupAvailability,
    product_1.ProductForm,
    product_1.ProductFormButton,
    product_1.ProductDetails,
    product_1.ProductBlock,
    product_model_1.ProductModel,
    cart_1.CartItem,
    cart_2.CartPage,
    cart_drawer_1.CartDrawer,
    free_shipping_bar_1.FreeShippingBar,
    product_1.ProductContent,
    product_1.ProductMedia,
    product_1.ProductMediaCarousel,
    product_1.VariantPicker,
    product_1.ColorSwatchesPicker,
    product_1.ProductModal,
    product_modal_image_wrap_1.ProductModalImageWrap,
    product_1.ProductModalButton,
    product_recommendations_1.ProductRecommendations,
    product_1.ProductRelatedBlock,
    recently_viewed_1.RecentlyViewed,
    search_drawer_1.SearchSidebarFormWrapper,
    cart_1.CartRemoveButton,
    clipboard_button_1.ClipboardButton,
    clipboard_button_1.ClipboardButtonTooltip,
    product_card_1.ProductCard,
    horizontal_product_card_1.HorizontalProductCard,
    vertical_product_card_1.VerticalProductCard,
    max_lines_truncate_1.MaxLinesComponent,
    customer_1.CountrySelector,
    inputs_1.SearchField,
    inputs_1.PasswordField,
    product_1.ZoomCursor,
    collection_page_1.ShopComponent,
    collection_page_1.ShopActiveFilters,
    collection_page_1.SidebarFiltersDesktop,
    collection_page_1.SidebarFiltersMobile,
    collection_page_1.ShopCollectionFilter,
    collection_page_1.FilterRemoveBtn,
    sort_list_1.SortList,
    collection_page_1.PriceRange,
    collection_page_1.ColumnSwitcher,
    collection_page_1.FiltersSubmitBtn,
    before_after_images_1.BeforeAfterImages,
    countdown_timer_1.CountdownTimer,
    product_1.ProductInformationDrawer,
    collection_page_1.SidebarFiltersStickyMobileButton,
    product_1.RecipientForm,
    shape_swatch_1.ShapeSwatch,
    customer_1.AddressesComponent,
    tabs_1.TabWithDynamicHeight,
    video_banner_1.VideoBanner,
    cart_drawer_1.CartDrawerItemsBlock,
    cart_drawer_1.CartDrawerInCartBannerBlock,
    cart_drawer_1.CartDrawerRelatedProducts,
    cart_drawer_1.CartDrawerRelatedProductsBlock,
    cart_drawer_1.CartDrawerTimerBlock,
    cart_drawer_1.CartDrawerHeader,
    cart_drawer_1.CartDrawerFooter,
    cart_1.CartItemsBlock,
    cart_1.CartButtonsBlock,
    cart_1.CartCountdownBlock,
    cart_1.CartRelatedProductsBlock,
    cart_1.CartOrderNotesBlock,
    cart_1.CartNote,
    cart_1.CartAppBlock,
    cart_1.CartSubtotalBlock,
    cart_1.CartInCartBannerBlock,
    cart_1.CartFreeShippingBarBlock,
    cart_count_1.CartCount,
    cart_drawer_1.CartDrawerFreeShippingBarBlock,
    cart_drawer_1.CartDrawerButtonsBlock,
    cart_1.CartRelatedProducts,
    share_1.ShareWrapper,
    share_1.ShareComponent,
    scrolling_text_1.ScrollingText,
    scrolling_text_1.ScrollingTextLine,
    hotspots_1.HotspotsComponent,
    collapsed_tags_1.CollapsedTags,
    article_card_1.ArticleTags,
    popups_1.PopupAgeVerifier,
    popups_1.PopupCookie,
    popups_1.PopupPromo,
    popups_1.PopupSignup,
    lookbook_1.LookbookComponent,
    lookbook_1.LookbookModal,
    map_component_1.MapComponent,
    map_1.StoreLocator,
    body_element_1.BodyElement,
    featured_navigation_1.FeaturedNavigation,
    image_slider_1.ImageSlider,
    close_cursor_1.CloseCursor,
    quote_1.QuoteComponent,
    testimonials_1.TestimonialsComponent,
    product_info_1.ProductInfo,
];
// @ts-expect-error
window.recentlyViewed = recently_viewed_1.RecentlyViewed;
const defineComponents = () => {
    components.forEach(utils_1.registerComponent);
};
exports.defineComponents = defineComponents;
